import(/* webpackMode: "eager" */ "/opt/build/repo/app/waiting-list/page.tsx")